import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-benefit-dialog',
  templateUrl: './benefit-dialog.component.html',
  styleUrls: ['./benefit-dialog.component.scss']
})
export class BenefitDialogComponent implements OnInit {
  compareList = [
    { label: 'Fire', fireInsurance: true, suriaShield: true },
    { label: 'Lightning', fireInsurance: true, suriaShield: true },
    { label: 'Explosion', fireInsurance: true, suriaShield: true },
    { label: 'Storm, Tempest, Hurricane, Cyclone, Typhoon, Windstorm', fireInsurance: false, suriaShield: true },
    { label: 'Riot, Strike & Malicious Damage', fireInsurance: false, suriaShield: true },
    { label: `Aircraft / Other Aerial Devices (Drone) Damage or Damage By Falling
    Trees Or Brances And Objects`, fireInsurance: false, suriaShield: true },
    { label: 'Flood, Bursting Or Overflowing Of Water Tanks Or Pipes', fireInsurance: false, suriaShield: true },
    { label: 'Impact Damage By Animals / Vehicles', fireInsurance: false, suriaShield: true },
    { label: 'Bush / Lalang Fire', fireInsurance: false, suriaShield: true },
    { label: 'Subsidence Or Landslip, Earthquake & Volcanic Eruption', fireInsurance: false, suriaShield: true },
    { label: 'Accidental Damage', fireInsurance: false, suriaShield: true },
    { label: 'Theft', fireInsurance: false, suriaShield: true },
    { label: '<strong>Rats Damaging Cables</strong>', fireInsurance: false, suriaShield: true },
    { label: '<strong>Power Surge</strong>', fireInsurance: false, suriaShield: true },
    { label: '<strong>Income / Saving Protection</strong>', fireInsurance: false, suriaShield: true },

  ]
  constructor(
    public dialogRef: MatDialogRef<BenefitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}
